import React, { useState } from 'react'
import {
  BASE_PRICE_MARKET,
  BASE_PRICE_RETAIL,
  BasePrice,
  HUNGRY_PERC,
  ITEM_MARKUP_PERCENTAGES,
} from '@constants'

interface ItemMarkupPercentageModalProps {
  title: string
  selectedPercentage: number
  onSave: (pct: number, basePrice: BasePrice) => void
  onCancel: () => void
  showBasePriceSelector?: boolean
  selectedBasePrice?: BasePrice
}

const ItemMarkupPercentageModal: React.FC<ItemMarkupPercentageModalProps> = ({
  title,
  selectedPercentage,
  onSave,
  onCancel,
  showBasePriceSelector = false,
  selectedBasePrice = BASE_PRICE_MARKET,
}) => {
  const [pendingPct, setPendingPct] = useState(selectedPercentage)
  const [pendingBase, setPendingBase] = useState<BasePrice>(selectedBasePrice)

  return (
    <>
      <div
        className="fixed inset-0"
        style={{ zIndex: 3999 }}
        onClick={onCancel}
      />
      <dialog
        open
        style={{ zIndex: 4000 }}
        className="p-4 border rounded shadow-lg bg-white w-80"
      >
        <p className="font-semibold mb-3">{title}</p>

        {showBasePriceSelector && (
          <div className="flex mb-3 rounded overflow-hidden border border-gray-300">
            <button
              type="button"
              onClick={() => setPendingBase(BASE_PRICE_MARKET)}
              className={`flex-1 py-1.5 text-sm font-medium transition-colors ${
                pendingBase === BASE_PRICE_MARKET
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Market Price
            </button>
            <button
              type="button"
              onClick={() => setPendingBase(BASE_PRICE_RETAIL)}
              className={`flex-1 py-1.5 text-sm font-medium transition-colors ${
                pendingBase === BASE_PRICE_RETAIL
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Retail Price
            </button>
          </div>
        )}

        {pendingBase === BASE_PRICE_RETAIL ? (
          <p className="text-sm text-gray-600 mb-4">
            Retail price calculations always use Hungry&apos;s fixed{' '}
            <span className="font-semibold">{HUNGRY_PERC * 100}% margin</span>.
          </p>
        ) : (
          <div className="flex flex-wrap gap-2 mb-4">
            {ITEM_MARKUP_PERCENTAGES.map((pct) => (
              <button
                key={pct}
                type="button"
                onClick={() => setPendingPct(pct)}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                  pendingPct === pct
                    ? 'bg-orange-500 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {pct * 100}%
              </button>
            ))}
          </div>
        )}

        <div className="flex justify-between">
          <button
            type="button"
            onClick={() => onSave(pendingPct, pendingBase)}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Save
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </dialog>
    </>
  )
}

export default ItemMarkupPercentageModal
